import OImage from 'components/reusable/OImage'
import { isEmpty } from 'lodash'
import React from 'react'

function Address ({ items }) {
  const generateMapURL = property => {
    if (isEmpty(property.location)) return ''
    const baseURL = 'https://www.google.com/maps?q='
    const propertyLocation = [
      property.location.coordinates[1],
      property.location.coordinates[0]
    ]
    return `${baseURL}${propertyLocation.join(',')}`
  }
  return (
    <>
      <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
        <tbody>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              City
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.city}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Community
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.community || 'N/A'}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Sub-community
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.subCommunity || 'N/A'}
            </th>
          </tr>
          {items?.country === 'UAE' && (
            <>
              {/* <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
                  Community
                </th>
                <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
                  {items?.community || 'N/A'}
                </th>
              </tr>
              <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  Sub-community
                </th>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  {items?.sub_community || 'N/A'}
                </th>
              </tr> */}
              <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  Street
                </th>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  {items?.street || 'N/A'}
                </th>
              </tr>
            </>
          )}
          {items?.country === 'Saudi' && (
            <>
              <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  Zone
                </th>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  {items?.zone || 'N/A'}
                </th>
              </tr>
              <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  District
                </th>
                <th
                  scope='row'
                  className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                >
                  {items?.district || 'N/A'}
                </th>
              </tr>
            </>
          )}

          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Building
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.building}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Unit Number
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.unit_number}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Street Width
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.streetWidth}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Property Length
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.propertyLength}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Property Width
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.propertyWidth}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Property Age
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.propertyAge}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              street 1
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.streetInfoOne}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              street 2
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.streetInfoTwo}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              street 3
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.streetInfoThree}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              street 4
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {items?.streetInfoFour}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Near by Facilities
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {Array.isArray(items?.near_facility) &&
                items?.near_facility
                  ?.map(nearFacility => nearFacility)
                  .join(', ') || 'N/A'}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              Near by Facilities (Arabic)
            </th>
            <th
              scope='row'
              className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
            >
              {Array.isArray(items?.near_facilityAr) &&
                items?.near_facilityAr
                  ?.map(nearFacilityAr => nearFacilityAr)
                  .join(', ') || 'N/A'}
              {/* {Array.isArray(items?.near_facilityAr) && items?.near_facilityAr?.length > 0 ? items?.near_facilityAr?.map((val, ind) => <span key={ind}>{val}, </span>) : 'N/A'} */}
            </th>
          </tr>
        </tbody>
      </table>
      <div className=''>
        <div className='text-50px font-medium text-lg p-6 pb-0'>Location</div>
        {items?.locationImage
          ? (
            <div className='mb-4 pl-6 pr-4 flex flex-wrap'>
              <a href={generateMapURL(items)} target='_blank' rel='noreferrer'>
                <OImage
                  height={350}
                  src={items?.locationImage}
                  className='w-full'
                  alt='image'
                />
              </a>
            </div>
            )
          : (
            <div className='flex justify-center items-center'>Not found</div>
            )}
      </div>
    </>
  )
}

export default Address
